"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.coreFontReducer = exports.coreFontActions = exports.TYPES_FONT = void 0;
var _reduxActions = require("redux-actions");
var _theme = require("../components/system/theme");
var _CodeConsts = require("../constants/CodeConsts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const CORE_FONT = 'coreFont';
const TYPES_FONT = exports.TYPES_FONT = {
  SET_FONTSIZE: CORE_FONT + 'SetFontSize'
};
const INIT_STATE = {
  fontsize: _theme.consts.defaultFontsize,
  fontsizeCd: _CodeConsts.CODE.FONTSIZE_CD.CODE_0
};
const coreFontActions = exports.coreFontActions = (0, _reduxActions.createActions)({
  [TYPES_FONT.SET_FONTSIZE]: function () {
    return {
      fontsizeCd: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
});
const coreFontReducer = exports.coreFontReducer = (0, _reduxActions.handleActions)({
  [TYPES_FONT.SET_FONTSIZE]: (state, action) => {
    const fontsizeCd = action.payload.fontsizeCd;
    if (fontsizeCd === _CodeConsts.CODE.FONTSIZE_CD.CODE_0 || fontsizeCd === _CodeConsts.CODE.FONTSIZE_CD.CODE_1) {
      return _objectSpread(_objectSpread({}, state), {}, {
        fontsize: fontsizeCd === _CodeConsts.CODE.FONTSIZE_CD.CODE_1 ? _theme.consts.bigFontsize : _theme.consts.defaultFontsize,
        fontsizeCd: fontsizeCd
      });
    } else {
      return {
        fontsize: _theme.consts.defaultFontsize,
        fontsizeCd: _CodeConsts.CODE.FONTSIZE_CD.CODE_0
      };
    }
  }
}, INIT_STATE);